let ls = {
    get: () => undefined,
    set: () => true,
};

try {
    ls = require('local-storage');
} catch (error) {
    console.warn('localStorage is not available now');
}

export default ls;
